import type { DemandFormModel } from './types.ts';

export type ApiResponse<T = any> = {
  success: boolean;
  data?: T;
  error?: string;
  code?: number;
};

export default class PassAPIConnector {
  private readonly apiKey: string;
  private readonly apiURL: string;

  constructor(apikey: string) {
    this.apiKey = apikey;
    this.apiURL = this.setNewPassRequestEnvironment();
  }

  getNewPassPayload(data: DemandFormModel): FormData | void {
    const { street, city, zipCode, filename, documentType, file } = data;

    if (!documentType || !file || !filename)
      throw new Error('Missing document type and/or file');

    const address = { street, city, zipCode };
    const formData = new FormData();
    formData.append('firstname', data.firstname);
    formData.append('lastname', data.lastname);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('address', JSON.stringify(address));
    formData.append('filename', data.filename);
    formData.append('documentType', data.documentType!);
    formData.append('file', data.file!);
    return formData;
  }

  async postNewPassRequest(payload: FormData): Promise<ApiResponse> {
    try {
      const headers = new Headers({ Authorization: `Bearer ${this.apiKey}` });
      const response = await fetch(`${this.apiURL}/form_pass_request/new`, {
        method: 'POST',
        body: payload,
        headers,
      });
      const result = await response.json();
      if (!response.ok) {
        return {
          success: false,
          error: result.message || 'Une erreur est survenue.',
          code: response.status,
        };
      }

      return {
        success: true,
        data: result,
      };
    }
    catch (error) {
      console.error('Error uploading form:', error);
      return {
        success: false,
        error: 'Impossible de contacter le serveur. Veuillez vérifier votre connexion.',
      };
    }
  }

  private setNewPassRequestEnvironment() {
    const isPreprod = window.location.origin.includes('localhost')
			|| window.location.origin.includes('.rc-preprod.com')
			|| window.location.origin.includes('preprod.marseille-tourisme.com')
			|| window.location.origin.includes('marseille-tourisme.wp.rc-preprod.com');
    if (isPreprod) {
      return 'https://public.api.youbook.rc-preprod.com/v3';
    }
    else {
      return 'https://public.api.youbook.travel/v3';
    }
  }
}
